/* eslint-disable max-len */
import React, { useCallback } from 'react';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ColorGroup, ColorSelector } from './../../../ui';

export const TopicWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useResolve(ToolManager);
    const color = tools.getSetting('topicTool', 'color') ?? ColorGroup.default[0];

    const onSelect = useCallback((value: string, complete?: boolean) => {

        tools.setSetting('topicTool', 'color', value);
        dispatch(toolEquip, ['topicTool']);

        if (complete) {
            widget.update({ open: false });
        }

    }, [widget]);

    return <Flexer relative>
        <ColorSelector color={color} onSelect={onSelect} />
    </Flexer>;
});
